import { init } from 'ramda';
import {
  HANDOFF,
  HANDOFF_ERROR,
  HANDOFF_MODAL_CLOSE,
  HANDOFF_RETRY,
  HANDOFF_SUCCESS,
  HANDOFF_TIMEOUT,
} from './constants';
import { assignPayments } from '../register/payment/reducer/payments/actions';
import { getPayments } from '../register/payment/reducer/payments/selectors';
import { getCart, getClient, getFetching } from './selectors';
import { CHECKOUT } from '../register/sale/constants';
import {
  createCart,
  resetSale,
  serializeOrder,
} from '../saleFlow/helpers';
import { handoff, handoffTimeout } from './actions';
import {
  redirectToAppointments,
  redirectToRegister,
} from '../main/payment/actions';
import { getOrderHasAppointment } from '../register/order/selectors';
import { setFetching } from '../register/payment/reducer/isFetching/actions';
import { canUserUseHandoff } from '../common/helpers/users';
import { isHandoffActive } from '../register/payment/reducer/handoff/selectors';
import { nonBlockingHandoffActive } from '../listeningMode/selectors';

const handleCheckout = async (store) => {
  const state = store.getState();
  if (!canUserUseHandoff(state.auth.permissions)) {
    return false;
  }
  const cart = await createCart(store, serializeOrder(store));
  store.dispatch(handoff(cart.id));
  return true;
};

const HANDOFF_TIMEOUT_INTERVAL = 5000;
const redirectToNextMasterScreen = (store) => {
  if (getOrderHasAppointment(store.getState())) {
    store.dispatch(redirectToAppointments());
    return;
  }
  store.dispatch(redirectToRegister());
};

const handleHandoffSuccess = (store) => {
  redirectToNextMasterScreen(store);
  resetSale(store);
};

let timeoutTimer;
const startTimeoutTimer = (store) => {
  timeoutTimer = setTimeout(
    () => store.dispatch(handoffTimeout()),
    HANDOFF_TIMEOUT_INTERVAL,
  );
};

const clearTimeoutTimer = () => {
  clearTimeout(timeoutTimer);
  timeoutTimer = null;
};

const removeLastPayment = (store) => {
  store.dispatch(assignPayments(init(getPayments(store.getState()))));
  store.dispatch(setFetching(false));
};

const handleHandoffTimeout = (store) => {
  removeLastPayment(store);
};

const handleHandoffRetry = (store) => {
  const state = store.getState();
  store.dispatch(handoff(getClient(state), getCart(state)));
};

const handleCloseModal = (store) => {
  removeLastPayment(store);
};

const middleware = store => next => async (action) => {
  let shouldPassAction = true;
  if (!nonBlockingHandoffActive(store.getState())) {
    return next(action);
  }

  switch (action.type) {
    case CHECKOUT:
      if (isHandoffActive(store.getState())) {
        shouldPassAction = !await handleCheckout(store);
      }
      break;

    case HANDOFF:
      startTimeoutTimer(store);
      break;

    case HANDOFF_SUCCESS:
      handleHandoffSuccess(store, action);
      clearTimeoutTimer(store);
      break;

    case HANDOFF_ERROR:
      if (getFetching(store.getState())) {
        clearTimeoutTimer(store);
        shouldPassAction = false;
      }
      shouldPassAction = true;
      break;

    case HANDOFF_TIMEOUT:
      handleHandoffTimeout(store);
      break;

    case HANDOFF_RETRY:
      handleHandoffRetry(store);
      break;

    case HANDOFF_MODAL_CLOSE:
      handleCloseModal(store);
      break;

    default:
  }

  if (shouldPassAction) next(action);
};

export default middleware;
